<template>
  <div class="w1200 bodybox">
    <div class="columnBox">
      <div class="homeClomuBox">
        <div class="homeClomuBoxInner">
          <div v-for="(item,index) in columnlist" :key="index" :class="currrentcolumn==index?'activename':'column_a'" @click="changeNowColumn(item.COLUMN_ID,index)">
            <span class="nameshow">{{ item.COLUMN_NAME }}</span><span v-show="index<columnlist.length-1" class="a_span">/</span>
          </div>
        </div>
      </div>
      <!--<div>{{columnlist}}</div>-->
      <!-- 栏目内容 -->
      <Centerlisthome :columnlist="currentData" />
      <div v-if="loadAll" class="atfoot loadMore">
        已经到底部了
      </div>
      <div v-else class="loadMore" @click="addMore">
        <span v-show="!isloading">加载更多>></span>
        <span v-show="isloading" class="el-icon-loading" style="font-size: 16px" />
      </div>
    </div>
    <!--热门专题 -->
    <!--<hotalbumHome :list="alldata.hotAlbum" />-->
    <!--<hotspecialtopicHome :list="alldata.hotSpecial" />-->
    <!-- 热门专辑 -->
  </div>
</template>
<script>
import Banner from '@/components/banner_smoll'
import Centerlisthome from '@/components/centerlist_home'
import hotspecialtopicHome from '@/views/components/hotspecialtopicHome'
import hotalbumHome from '@/views/components/hotalbumHome'
import { addMoreColumn, InterestedHome, getContentPagerExp5 } from '@/api/api.js'

export default {
  components: { Centerlisthome, hotspecialtopicHome, hotalbumHome, Banner },
  props: ['columnlist', 'initdata', 'alldata'],
  data() {
    return {
      isloading: false,
      currentPage: 1,
      currentID: '1',
      currrentcolumn: 0,
      loadAll: false,
      page: 1,
      interestedHomeData: [],
      currentData: this.alldata.allContent.listMapData

    }
  },
  computed: {

  },
  watch: {

  },
  mounted() {
    this.page = this.alldata.allContent.page
    // console.log(this.alldata.allContent)
    if (this.page == 0) {
      this.page = 1
    }
    if (this.page === this.currentPage * 1) {
      this.loadAll = true
    }
  },
  methods: {
    changeNowColumn: function(ID, index) {
      this.currentPage = 1
      this.currentID = ID
      var obj = {}
      obj.index = '1'
      obj.size = '24'
      if (ID != 1) {
        obj.columnId = ID
      }
      this.currrentcolumn = index
      this.loadAll = false
      if (ID === '1') {
        getContentPagerExp5(obj).then(res => {
          this.currentData = []
          this.currentData = this.currentData.concat(res.data.listMapData)
          this.page = res.data.page
        })
      } else {
        addMoreColumn(obj).then(res => {
          this.currentData = []
          this.currentData = this.currentData.concat(res.data.listMapData)
          this.page = res.data.page
          if (this.page == 0) {
            this.page = 1
          }
          if (this.currentPage >= this.page) {
            this.loadAll = true
          }
        })
      }
    },
    // /加载更多
    addMore: function() {
      this.isloading = true
      var obj = {}
      obj.index = this.currentPage + 1
      obj.size = '24'
      if (this.currentID === '1') {
        // console.log(this.currentPage)
        getContentPagerExp5(obj).then(res => {
          this.currentData = this.currentData.concat(res.data.listMapData)
          this.isloading = false
          this.currentPage++
          if (this.currentPage >= this.page) {
            this.loadAll = true
          }
        })
      } else {
        obj.columnId = this.currentID
        addMoreColumn(obj).then(res => {
          this.currentData = this.currentData.concat(res.data.listMapData)
          this.isloading = false
          this.currentPage++
          if (this.currentPage >= this.page) {
            this.loadAll = true
          }
        })
      }
    }
  }

}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .bannerBox{
    display: none;
  }
  .homeClomuBoxInner{
    height: 60px;
    line-height: 60px;
    background-color: #fff;
  }
  .bodybox{
    background-color: #fafafa;
  }
.columnBox{
    margin: 20px auto;
    margin-top: 0;
    text-align: center;
  padding-top: 20px;
  .activename{
    display: inline-block;
    cursor: pointer;
    .a_span{
      margin: 0 16px;
    }
    .nameshow{
      color: #ed4040;
      font-size: 16px;
      font-weight: 600;
    }

  }
    .column_a{
      display: inline-block;
      cursor: pointer;
      font-size: 16px;
      .a_span{
          margin: 0 16px;
      }
      .nameshow{
          font-size: 16px;
          color: #333333;
          font-weight: 600;
          &:hover{
            color: #ed4040;
          }
        }
    }
  .loadMore{
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    color: #999999;
    background-color: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    cursor: pointer;
    display:inline-block;
    width: 100%;
    margin-top: 20px;
    transition: 0.5s;
    &:hover{
      color: #ed4040;
      border: 1px solid #ed4040;
    }
  }
  .atfoot{
    cursor: auto;
  }
}
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px){
    .homeClomuBox{
      width: 100%;
      overflow: hidden;
      overflow-x: auto;
      padding-bottom: 20px;
      .homeClomuBoxInner{
        white-space :  nowrap;
        padding: 0 20px;
      }
    }
    .bannerBox{
      display: block;
      width: 100%;
      height: auto;
    }
  }
</style>
